import "core-js/modules/es.array.push.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/course_empty1.png';
const _withScopeId = n => (_pushScopeId("data-v-6f86d7ae"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "contain"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "image-slot"
}, [/*#__PURE__*/_createElementVNode("img", {
  style: {
    "height": "169px"
  },
  src: _imports_0,
  alt: ""
})], -1));
const _hoisted_4 = {
  key: 0,
  class: "live-tag"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "living"
}, " 直播课 ", -1));
const _hoisted_6 = [_hoisted_5];
const _hoisted_7 = {
  class: "course-card"
};
const _hoisted_8 = ["title"];
const _hoisted_9 = {
  class: "card-bottom"
};
const _hoisted_10 = {
  key: 0,
  class: "course-price free"
};
const _hoisted_11 = {
  key: 1,
  class: "course-price"
};
const _hoisted_12 = {
  class: "course-address"
};
const _hoisted_13 = {
  key: 0,
  class: "start-data"
};
import router from '@/router';
import { getImgUrl } from '@/utils/common';
export default {
  __name: 'index',
  props: {
    courseData: {
      type: Array,
      default: () => []
    }
  },
  setup(__props) {
    const props = __props;
    const clickCourse = val => {
      router.push({
        path: '/course/detail',
        query: {
          id: val,
          tab: 'introduction'
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.courseData, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "course-block",
          key: item,
          onClick: $event => clickCourse(item.id)
        }, [_createVNode(_component_el_image, {
          class: "course-img",
          src: item.cover ? _unref(getImgUrl)(item.cover) : '',
          lazy: ""
        }, {
          error: _withCtx(() => [_hoisted_3]),
          _: 2
        }, 1032, ["src"]), item.coursePlayType === '1' ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
          class: "course-title",
          title: item.courseName
        }, _toDisplayString(item.courseName), 9, _hoisted_8), _createElementVNode("div", _hoisted_9, [item.free === '0' ? (_openBlock(), _createElementBlock("div", _hoisted_10, " 免费 ")) : (_openBlock(), _createElementBlock("div", _hoisted_11, " ￥ " + _toDisplayString(item.price), 1)), _createElementVNode("div", _hoisted_12, [item.address ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(item.address), 1)) : _createCommentVNode("", true)])])])], 8, _hoisted_2);
      }), 128))]);
    };
  }
};